export const PATTERN = {
    NUMBER: /^[0-9]+$/,
    NUMBER_WITH_DECIMAL: /^[0-9]*(\.\d{1,2})?$/,
    NEGATIVE_NUMBER: /^-?[0-9]+$/,
    NEGATIVE_NUMBER_WITH_DECIMAL: /^-?[0-9]*(\.\d{1,2})?$/,
    EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
    ALPHA_NUMARIC: /^[a-zA-Z0-9 ._-]+$/,
    DOMAIN: /^\*$|^([a-zA-Z0-9][a-zA-Z0-9-]{0,}[a-zA-Z0-9]\.)?[a-zA-Z0-9][a-zA-Z0-9-]{0,}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/,
    DOMAIN_WITH_HTTP: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([a-zA-Z0-9][a-zA-Z0-9-]{0,}[a-zA-Z0-9]\.)?[a-zA-Z0-9][a-zA-Z0-9-]{0,}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/,
    URL: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/,
    TELEPHONE: /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{8,11}$/
}